import { createSelector } from 'reselect'
import featureStateSelector from './featureStateSelector'

export const currentPageSelector = createSelector(featureStateSelector, (state) => state.pagination.currentPage)
